export const translations = {
  locale: 'en',
  SettingsFeesApp: {
    CLIENT_FEES_HEADER: 'Default Client Fees',
    ACCOUNT_FEES_HEADER: 'My Account Fees',
    WITHDRAWAL_HEADER: 'Withdrawal Fees',
    WITHDRAWAL_TEXTAREA: 'Fees as agreed with your member/broker.'
  },
  FeesButtonGroup: {
    UPDATE_FEES_BTN: 'Update Fees',
    CANCEL_FEES_BTN: 'Cancel',
    RESET_FEES_BTN: 'Reset to default'
  },
  FeesConfirmation: {
    HEADER: 'Confirm Fee Change',
    CONFIRM_FEES_BTN: 'Confirm Fee Change',
    CANCEL_FEES_BTN: 'Cancel',
    CONFIRM_BODY_TEXT: 'Please confirm that you wish to change fee(s).',
    UPDATE_SUCCESS: 'Fees have been successfully updated'
  },
  FeesTable: {
    SPINNER_TITLE: 'Fee Rate (%)',
    EWARRANT_SPINNER_TITLE: 'Fee Charged ($)',
    TIER_HEADER: 'Tier',
    BOUND_HEADER: 'Upper-Bound Value',
    RATE_HEADER: 'Fee Rate (%)',
    EWARRANT_HEADER: 'COST PER CONTRACT ($)'
  },
  MdTabs: {
    'Execution Fees': 'Execution Fees',
    'Storage Fees': 'Storage Fees',
    Gold: 'Gold',
    Silver: 'Silver',
    Platinum: 'Platinum',
    Kinesis: 'Kinesis',
    optIn: 'Opt-In to Bullion Coin',
    includeClients: 'Include Clients',
    'Private Client': 'Private Client',
    'Full Member': 'Full Member',
    'Introducing Broker': 'Introducing Broker',
    'Available': 'Available',
    'Created' : 'Created',
    'Certified': 'Certified',
    'Cancelled': 'Cancelled',
    'Certification': 'Certification',
    'Cancellation': 'Cancellation',
    'E-Warrant Fees': 'E-Warrant Fees'
  },
  MdClientSelect: {
    PLACEHOLDER: 'Select or Filter Client'
  },
  MdVaultItemSelect: {
    PLACEHOLDER: 'Select or Filter Vault Item'
  },
  MdProductSelect: {
    ALL_METALS: 'All',
    Gold: 'Gold',
    Silver: 'Silver',
    Platinum: 'Platinum',
    Kinesis: 'Kinesis',
    '1 kg Bar': '1 kg Bar',
    'Austrian Philharmonic': 'Austrian Philharmonic',
    'American Eagle': 'American Eagle',
    '100 oz Bar': '100 oz Bar',
    '10 oz Pool NGD': '10 oz Pool NGD',
    'Australian Koala': 'Australian Koala',
    '1/2 oz Pool': '1/2 oz Pool',
    '100 g Bar': '100 g Bar',
    'American Buffalo': 'American Buffalo',
    'Australian Kangaroo': 'Australian Kangaroo',
    'Chinese Panda': 'Chinese Panda',
    'Australian Kookaburra/Koala': 'Australian Kookaburra/Koala',
    'Mexican Libertad': 'Mexican Libertad',
    'Canadian Maple': 'Canadian Maple',
    'Australian Platypus': 'Australian Platypus',
    'South African Krugerrand': 'South African Krugerrand',
    '1 oz Pool': '1 oz Pool',
    '1/2 oz Pool NGD': '1/2 oz Pool NGD',
    '10 oz Swiss Bar': '10 oz Swiss Bar',
    '10 oz Minted Bar': '10 oz Minted Bar',
    '1 oz Pool GD': '1 oz Pool GD',
    '1 oz Pool NGD': '1 oz Pool NGD',
    '1 kg Bar 995': '1 kg Bar 995',
    '100 g Cast Bar': '100 g Cast Bar',
    '100 g Swiss Bar': '100 g Swiss Bar',
    'Wholesale AAU 10 kg': 'Wholesale AAU 10 kg',
    'Wholesale AAG 25,000 oz': 'Wholesale AAG 25,000 oz',
    '100 g Cast Bar 9999': '100 g Cast Bar 9999',
    '1 kg Bar 999': '1 kg Bar 999'
  },
  MdHubSelect: {
    PLACEHOLDER: 'Select or Filter Hub',
    ALL_HUBS: 'All Hubs',
    'Brisbane' : 'Brisbane',
    'Sydney' : 'Sydney',
    'Singapore' : 'Singapore',
    'Hong Kong' : 'Hong Kong',
    'New York' : 'New York',
    'London' : 'London',
    'Zurich' : 'Zurich',
    'Dubai' : 'Dubai',
    'Melbourne' : 'Melbourne',
    'Adelaide' : 'Adelaide',
    'Perth' : 'Perth',
    'Shanghai' : 'Shanghai',
    'Bangkok' : 'Bangkok',
    'Istanbul' : 'Istanbul',
    'Auckland' : 'Auckland',
    'Jakarta' : 'Jakarta',
    'BNE': 'BNE',
    'SYD': 'SYD',
    'SIN': 'SIN',
    'HKG': 'HKG',
    'NYC': 'NYC',
    'LON': 'LON',
    'ZRH': 'ZRH',
    'DXB': 'DXB',
    'MEL': 'MEL',
    'ADL': 'ADL',
    'PER': 'PER',
    'SHA': 'SHA',
    'BKK': 'BKK',
    'IST': 'IST',
    'AKL': 'AKL',
    'CGK': 'CGK'
  },
  MdTable: {
    hin: 'hin',
    accountName: 'account',
    metalName: 'metal',
    hubName: 'hub',
    productName: 'product',
    availableForEvw: 'Available For EVW',
    evwInProgress: 'EVW in progress',
    requesterName: 'Requester',
    evwCreatedAt: 'Created',
    serialNumber: 'Serial Number',
    hallmark: 'Hallmark',
    certifiedAt: 'Certified',
    cancelledAt: 'Cancelled',
    warrantNumber: 'Warrant Number'
  },
  MdDropdown: {
    'Export': 'Export',
    'Export to CSV': 'Export to CSV'
  },
  EvwSidePanel: {
    CREATE_EVW_MODAL_TEXT: 'A certification fee will be charged if this e-warrant is certified. Are you sure you wish to create the e-warrant?',
    CANCEL_REQUESTED_MODAL_TEXT: 'Do you wish to proceed with the cancellation of the e-warrant?',
    CANCEL_CERTIFIED_MODAL_TEXT: 'A cancellation fee will be charged for the cancellation of this e-warrant. Do you wish to proceed with the cancellation of the e-warrant?',
    CERTIFY_EVW_MODAL_TEXT: 'A certification fee will be charged for the certification of this e-warrant. Are you sure you wish to certify the e-warrant?',
    CHANGE_VAULT_ITEM_EVW_MODAL_TEXT: 'Are you sure you wish to update the vault item linked to this e-warrant?',
    EWARRANT_CREATED: 'Ewarrant successfully created!',
    HUB: 'Hub',
    HIN: 'HIN',
    SERIAL_NUMBER: 'Serial Number',
    HALLMARK: 'Hallmark',
    WARRANT_NUMBER: 'Warrant Number',
    PRODUCT: 'Product',
    AVAILABLE: 'Available',
    IN_PROGRESS: 'In Progress'
  },
  MdAccordionTable: {
    hin: 'Hin',
    accountName: 'Account Name',
    selectBtn: ''
  },
  AccountStatementContainer:{
    RUN_REPORT: 'Run Statement Report',
    SELECT_DATE_RANGE: 'Select a date range'
  }
}



// WEBPACK FOOTER //
// ./react/translations/en.ts